import { useState } from "react";
import bKash from "../../../assets/payment/bKash.png";
import india from "../../../assets/payment/india.png";
import islamiBank from "../../../assets/payment/islamic bank.png";
import nagad from "../../../assets/payment/nagad.png";
import paypal from "../../../assets/payment/paypal.png";
import rocket from "../../../assets/payment/rocket.png";
import stcPay from "../../../assets/payment/stc_pay.png";
import taptap from "../../../assets/payment/taptap.png";
import upay from "../../../assets/payment/upay.png";

function InlineCopy({ text, className }) {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(text).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000); // remove "copied" after 2s
    });
  };

  return (
    <span className={`cursor-pointer`} onClick={handleCopy}>
      <span className={` ${className}`}> {text}</span>
      {copied && <span className="ms-2">copied</span>}
    </span>
  );
}

const payment_number_list = [
  {
    method: "nagad",
    text: "01883998081",
    color: "bg-orange-200",
    icon: nagad,
  },
  {
    method: "upay",
    text: "01883998081",
    color: "bg-slate-200",
    icon: upay,
  },
  {
    method: "rocket",
    text: "018839980815",
    color: "bg-indigo-200",
    icon: rocket,
  },
  {
    method: "paypal",
    text: "faisal42abdullah@gmail.com",
    color: "bg-sky-200",
    icon: paypal,
  },
  {
    method: "stcPay",
    text: "+966535017346",
    color: "bg-sky-200",
    icon: stcPay,
  },
  {
    method: "bKash",
    text: "01883998081",
    color: "bg-red-200",
    icon: bKash,
  },
  {
    method: "bKash",
    text: "01955756202",
    color: "bg-red-200",
    icon: bKash,
  },
];

export default function PaymentAccounts() {
  const [copiedIndex, setCopiedIndex] = useState(null);

  const handleCopy = (text, index) => {
    navigator.clipboard.writeText(text).then(() => {
      setCopiedIndex(index); // mark this item as copied

      // Optional: remove "copied" after 2 seconds
      setTimeout(() => setCopiedIndex(null), 2000);
    });
  };
  return (
    <section>
      <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-5">
        {payment_number_list.map((item, index) => (
          <div
            key={index}
            className={`p-5 flex ${item.color} rounded items-center cursor-pointer`}
            title="Click to copy"
            onClick={() => handleCopy(item.text, index)}
          >
            <img className="w-8 mr-5" src={item.icon} alt={item.method} />
            {item.text.includes("@") ? (
              <span className="">
                <span className="font-bold">{item.text.split("@")[0]}</span>@
                {item.text.split("@")[1]}
              </span>
            ) : (
              <p className="text-2xl font-bold">{item.text}</p>
            )}
            {copiedIndex === index && <span className="ms-3 ">copied</span>}
          </div>
        ))}
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 items-center">
        <div>
          <p className="mt-5">সরাসরি ব্যাংকে পাঠাতে পারেন</p>
          <div className="flex gap-5 mt-5">
            <div className="w-16">
              <img className="rounded" src={islamiBank} alt="" />
            </div>
            <div>
              <p className="" title="click to copy">
                {" "}
                A/C Name:{" "}
                <InlineCopy
                  className="text-green-600 font-bold"
                  text="Abdullah Al Baki"
                />
              </p>
              <p className="" title="click to copy">
                {" "}
                A/C No:{" "}
                <InlineCopy
                  className="text-green-600 font-bold"
                  text="20501170200739805"
                />
              </p>
              <p className="" title="click to copy">
                {" "}
                Branch:{" "}
                <InlineCopy
                  className="text-green-600 font-bold"
                  text="Rangpur"
                />
              </p>
              <p className="" title="click to copy">
                {" "}
                Branch Code:{" "}
                <InlineCopy
                  className="text-green-600 font-bold"
                  text="IBBLBDDH117"
                />
              </p>
              <InlineCopy className=" mb-5" text="Islami Bank Bangladesh Ltd" />
            </div>
          </div>
        </div>
        <div>
          <p className="mt-5">ট্যাপট্যাপ সেন্ডের মাধ্যমেও টাকা পাঠাতে পারেন</p>
          <div className="flex gap-5 mt-5">
            <div className="w-16">
              <img className="" src={taptap} alt="" />
            </div>
            <div>
              <p className="">
                {" "}
                Phone :{" "}
                <InlineCopy
                  className="text-green-600 font-bold"
                  text="+8801883998081"
                />
              </p>
              <p className="">
                {" "}
                Full Name:{" "}
                <InlineCopy
                  className="text-green-600 font-bold"
                  text="Faisal Faisal"
                />
              </p>
            </div>
          </div>
        </div>
        <div className="mt-5 flex gap-5">
          <div className="w-16">
            <img className="rounded" src={india} alt="" />
          </div>
          <div>
            <p className="">
              ভারত থেকে ভর্তি হওয়ার জন্য ফোন পে নাম্বার পেতে ইনবক্সে মেসেজ দিন।
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
